import styled from "styled-components";

export type StatusBadgeVariant =
  | "aviso"
  | "sucesso"
  | "neutro"
  | "erro"
  | "info"
  | "roxo"
  | "rosa";

const variantStyles: Record<
  StatusBadgeVariant,
  { backgroundColor: string; color: string }
> = {
  aviso: { backgroundColor: "#FFF3CD", color: "#CC7A00" },
  sucesso: { backgroundColor: "#E6F9F0", color: "#2EAD65" },
  neutro: { backgroundColor: "#F2F2F2", color: "#6E6E6E" },
  erro: { backgroundColor: "#FFE4E4", color: "#EE5353" },
  info: { backgroundColor: "#E7F0FF", color: "#1F6FEB" },
  roxo: { backgroundColor: "#FFF0FC", color: "#EC04B9" },
  rosa: { backgroundColor: "#FFE3EC", color: "#D6336C" },
};

interface BadgeProps {
  variant: StatusBadgeVariant;
  width?: string;
}

export const Badge = styled.span<BadgeProps>`
  display: inline-block;
  padding: 5px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  min-width: 70px;
  text-align: center;
  ${({ width }) => width && `width: ${width};`}
  background-color: ${({ variant }) => variantStyles[variant].backgroundColor};
  color: ${({ variant }) => variantStyles[variant].color};
  border: 1px solid ${({ variant }) => variantStyles[variant].color};
`;
